<template>
  <footer class="designerFooter d-flex align-center px-4 mt-50">

    <router-link v-if="$vuetify.breakpoint.smAndUp" class="prev generic-image-link" :to="{ name: 'Designer', params: { slug: prevItem._slug, designers: designers } }">
      <seo-v-img cover class="thumbnail d-none d-sm-block" :width="$vuetify.breakpoint.mdAndDown ? 300 : 400" :aspect-ratio="0.8" :src="`/media/${prevItem.heroImage.id}`" :lazy-src="JSON.parse(prevItem.heroImage.metaData)['image-lazy-src']"> <div class="image-dark-cover" /></seo-v-img>
      <div class="wrapper">
        <span class="label">{{$root.siteSettings.previousLabel}}</span>
        <span class="link text-uppercase" v-html="prevItem && hypenate(prevItem.name)" />
      </div>
    </router-link>

    <router-link class="next generic-image-link" :to="{ name: 'Designer', params: { slug: nextItem._slug, designers: designers } }">
      <seo-v-img cover class="thumbnail d-none d-sm-block" :width="$vuetify.breakpoint.mdAndDown ? 300 : 400" :aspect-ratio="0.8" :src="`/media/${nextItem.heroImage.id}`" :lazy-src="JSON.parse(nextItem.heroImage.metaData)['image-lazy-src']"> <div class="image-dark-cover" /></seo-v-img>
      <div class="wrapper">
        <span class="label">{{$root.siteSettings.nextLabel}}</span>
        <span class="link text-uppercase"  v-html="nextItem && hypenate(nextItem.name)" />
      </div>
    </router-link>

  </footer>
</template>

<script>
export default {
  name: 'DesignerFooter',
  props: {
    prevItem: {
      // validator: prop => typeof prop === 'object' || prop === null,
      required: true
    },
    nextItem: {
      // validator: prop => typeof prop === 'object' || prop === null,
      required: true
    },
    designers: {
      required: true
    }
  },
  methods: {
    hypenate (str) {
      return str.replace(/\u200B/g, '&shy;')
    }
  }
}
</script>

<style scoped lang="scss">
  .mt-50 {
    margin-top: 200px;
  }

  .designerFooter {
    color: #fff;
    background-color: #ffcbc4;
    min-height: 200px;
    padding: 100px 30px;
    justify-content: space-evenly;

    h2 {
      cursor: pointer;
    }

    .prev,
    .next {
      position: relative;

      .wrapper {
        position: absolute;
        top: 75%;
      }
    }

    .label {
      //position: absolute;
      display: block;
      //top: 70%;
      color: #fff;
      font-family: $body-font-family;
      font-size: 1.1rem;
      // mix-blend-mode: difference;
    }

    .link {
      color: #f4f4f8;
      font-family: $heading-font-family;
      font-size: 4.5vh;
      max-width: 230px;
      display: inline-block;
      line-height: 1.3;
      hyphens: auto;
      // mix-blend-mode: difference;
    }

    .prev {
      .wrapper {
        left: -5%;
      }

    }

    .next {
      text-align: right;

      .wrapper {
        right: -5%;
        @include breakpoint('xs-only') {
          position: relative;
          text-align: left;
        }
      }
    }
  }
</style>
